<template>
    <div>
        <!-- Teams List Loader -->
        <div v-if="teamsLoader" class="loader-overlay">
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>

        <div id="accordionTeam">
            <div
                v-for="(item, index) in teams"
                :key="'team-collapse-'+index"
                class="card mb-0">
                <div class="card-header custom-card-header" :id="item.id + 'heading'">
                    <h5 class="mb-0">
                        <button
                            data-toggle="collapse"
                            :data-target="'#collapse' + item.id"
                            aria-expanded="false"
                            :aria-controls="'#collapse' + item.id"
                            class="btn btn-link custom-btn-link text-grey-darker"
                            @click="toggleAccordion(item.id)">
                            <span class="float-left"><i class="fa fa-angle-right text-primary mr-3"></i>{{ item.name }}</span><br>
                        </button>
                    </h5>
                </div>
                <div
                    :id="'#collapse' + item.id"
                    class="collapse"
                    :class="{ show: item.expanded }"
                    :aria-labelledby="item.id + 'heading'"
                    data-parent="#accordionTeam">
                    <!-- Search Bar and Column Manager -->
                    <div class="bg-grey-custom d-flex align-items-center border-1">
                        <!-- Search Input -->
                        <div class="min-w-25 search-container">
                            <input type="text"
                                   v-model="filterSelected.search"
                                   class="form-control focus:border-followup-nav"
                                   placeholder="Search name or email address"
                                   @input="debounceFilter">
                            <i class="fa fa-search text-primary"></i>
                        </div>
                    </div>

                    <!-- Users List Table -->
                    <div class="custom-card-body bg-white">
                        <div class="border-1 position-relative">
                            <!-- Table Loader -->
                            <div
                                class="loader-overlay d-none"
                                :class="'loader-overlay-team-' + item.id">
                                <div class="spinner-border text-primary" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>

                            <!-- Table -->
                            <div class="table-responsive">
                                <table class="table table-bordered multiple-team-user-table" ref="MembersTable">
                                    <thead class="text-nowrap">
                                    <tr>
                                        <th class="text-uppercase font-size-13 align-middle cursor-pointer">Name</th>
                                        <th class="text-uppercase font-size-13 align-middle cursor-pointer">Email</th>
                                        <th class="text-uppercase font-size-13 align-middle cursor-pointer">Role</th>
                                        <th class="text-uppercase font-size-13 align-middle cursor-pointer">Actions</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(user, index) in teamUsers" :key="index"
                                        class="bg-white hover:bg-grey-lighter table-row font-size-14 table-data-row">

                                        <td class="align-middle">{{ user.name }}</td>
                                        <td class="align-middle">{{ user.email }}</td>
                                        <td class="align-middle">{{ user.role }}</td>
                                        <td>
                                            <div :id="`action-buttons-div-${item.id}-${index}`">
                                                <button
                                                    v-if="user.default_role !== 'owner'"
                                                    class="btn bg-grey-light btn-sm"
                                                    @click="editUserPermissions(user)">Edit permissions</button>
                                                <button
                                                    class="btn bg-grey-light btn-sm dropdown-toggle"
                                                    :id="`actionPopoverButton-${item.id}-${index}`"
                                                    tabindex="0">
                                                    Actions
                                                </button>
                                                <b-popover
                                                    :target="`actionPopoverButton-${item.id}-${index}`"
                                                    :ref="`actionPopoverButton-${item.id}-${index}`"
                                                    placement="bottom"
                                                    custom-class="filter-popover-class"
                                                    triggers="focus">
                                                    <div class="justify-content-center nav-dropdown-menu my-2">
                                                        <div
                                                            @click="redirectToUserSettings(user.id)"
                                                            class="py-2 px-3 pointer hover:theme-custom-background hover:theme-custom-color font-size-16">
                                                            User Settings
                                                        </div>
                                                        <div
                                                            @click="redirectToUserQuotas(user.id)"
                                                            class="py-2 px-3 pointer hover:theme-custom-background hover:theme-custom-color font-size-16">
                                                            User Quotas
                                                        </div>
                                                        <div
                                                            @click="redirectToUserSalesBehaviorSettings(user.id)"
                                                            class="py-2 px-3 pointer hover:theme-custom-background hover:theme-custom-color font-size-16">
                                                            User Sales Behavior Settings
                                                        </div>
                                                        <div
                                                            v-if="user.default_role !== 'owner'"
                                                            @click="editUserTeams(user)"
                                                            class="py-2 px-3 pointer hover:theme-custom-background hover:theme-custom-color font-size-16">
                                                            Edit teams
                                                        </div>
                                                        <div
                                                            v-if="user.default_role !== 'owner'"
                                                            class="py-2 px-3 pointer hover:theme-custom-background hover:theme-custom-color font-size-16">
                                                            Copy permissions to new users
                                                        </div>
                                                        <div
                                                            @click="editUserColor(user)"
                                                            class="py-2 px-3 pointer hover:theme-custom-background hover:theme-custom-color font-size-16">
                                                            Edit Color
                                                        </div>
                                                        <div
                                                            v-if="user.default_role !== 'owner'"
                                                            @click="lockUnlockUser(user.id, user.is_locked)"
                                                            class="py-2 px-3 pointer hover:theme-custom-background hover:theme-custom-color font-size-16">
                                                            {{ user.is_locked ? 'Unlock' : 'Lock' }}
                                                        </div>
                                                        <div
                                                            @click="resetPasswordLink(user)"
                                                            class="py-2 px-3 pointer hover:theme-custom-background hover:theme-custom-color font-size-16">
                                                            Reset password
                                                        </div>
                                                        <div v-if="user.default_role !== 'owner'" class="dropdown-divider"></div>
                                                        <div
                                                            v-if="user.default_role !== 'owner' && user.is_active"
                                                            @click="deactivateUsers(user.id)"
                                                            class="py-2 px-3 pointer hover:theme-custom-background hover:theme-custom-color font-size-16">
                                                            Deactivate user
                                                        </div>
                                                        <div
                                                            v-if="user.default_role !== 'owner' && !user.is_active"
                                                            @click="activateUsers(user.id)"
                                                            class="py-2 px-3 pointer hover:theme-custom-background hover:theme-custom-color font-size-16">
                                                            Reactivate user
                                                        </div>
                                                        <div v-if="user.default_role !== 'owner'" class="py-2 px-3">
                                                            <small>Only deactivated users can be removed from your account.</small>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <!-- Pagination -->
                            <div
                                v-if="pagination.meta.total > pagination.meta.per_page"
                                :key="item.id"
                                class="flex justify-content-center mt-5">
                                <b-pagination
                                    @change="goToPage"
                                    v-model="pagination.meta.current_page"
                                    :total-rows="pagination.meta.total"
                                    :per-page="pagination.meta.per_page"
                                    first-text="First"
                                    prev-text="Prev"
                                    next-text="Next"
                                    last-text="Last">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <manage-user-permissions-modal
            v-if="selectedTeam"
            :team="selectedTeam"
            parent-id="MultipleTeamUsers"
            ref="MultiTeamManageUserPermissionsModal"
            v-on:user-permissions-updated="userPermissionsUpdated">
        </manage-user-permissions-modal>

        <edit-user-color-modal
            parent-id="MultipleTeamUsers"
            ref="EditUserColorModal">
        </edit-user-color-modal>

        <edit-user-teams-modal
            parent-id="MultipleTeamUsers"
            ref="EditUserTeamsModal">
        </edit-user-teams-modal>
    </div>
</template>

<script>
import ManageUserPermissionsModal from "./manage-user-permissions-modal.vue";
import EditUserColorModal from "./edit-user-color-modal.vue";
import EditUserTeamsModal from "./edit-user-teams-modal.vue";

export default {
    name: 'multiple-team-management-tab',
    components: {EditUserTeamsModal, EditUserColorModal, ManageUserPermissionsModal},
    props: ['user', 'team'],
    data() {
        return {
            teams: [],
            selectedTeam: null,
            selectedTeamId: null,
            teamUsers: [],
            pagination: {
                meta: {},
                links: {}
            },
            filterSelected: {
                search: null,
                timeout: null
            },
            teamsLoader: false
        }
    },
    mounted() {
        this.getUserAllTeams();
    },
    methods: {
        getUserAllTeams() {
            let self = this;
            self.teamsLoader = true;

            axios.get('/settings/'+this.team.id+'/members/get-all-teams').then(({data}) => {
                self.teamsLoader = false;
                self.teams = data.data;
            }).catch((error) => {
                self.teamsLoader = false;
            });
        },
        toggleAccordion(id) {
            this.teams.forEach((item) => {
                const element = document.getElementById('collapse' + id);

                if(item.id === id) {
                    const willExpand = !item.expanded;
                    item.expanded = willExpand;

                    $(element).collapse(item.expanded ? 'show' : 'hide');

                    if(willExpand) {
                        this.selectedTeam = item;
                        this.selectedTeamId = item.id;
                        this.filterSelected.search = null;
                        this.filterSelected.timeout = null;
                        this.getTeamUsers();
                    }
                }
                else {
                    item.expanded = false;
                    $(element).collapse('hide');
                }
            });
        },
        getTeamUsers(page = 1) {
            let self = this;
            self.teamUsers = [];
            $(`.loader-overlay-team-${this.selectedTeamId}`).removeClass('d-none');

            const payload = {
                page,
                teamId: this.selectedTeamId,
                filters: JSON.stringify(self.filterSelected)
            };

            axios.get('/settings/members/get-team-all-users', {params: payload}).then(({data}) => {
                $(`.loader-overlay-team-${this.selectedTeamId}`).addClass('d-none');
                self.teamUsers = data.data;
                self.pagination.links = data.links;
                self.pagination.meta = data.meta;
                Bus.$emit('userUpdatedMultipleTeamsTab', true);
            }).catch((error) => {
                $(`.loader-overlay-team-${this.selectedTeamId}`).addClass('d-none');
            });
        },
        goToPage(page) {
            this.getTeamUsers(page);
        },
        editUserPermissions(user) {
            this.$refs.MultiTeamManageUserPermissionsModal.open(user);
        },
        redirectToUserSettings(userId) {
            window.location = route('settings.member.notification-settings.edit-user-settings', {team: this.selectedTeamId, member: userId});
        },
        debounceFilter() {
            clearTimeout(this.filterSelected.timeout);
            this.filterSelected.timeout = setTimeout(() => {
                this.getTeamUsers();
            }, 700, this);
        },
        redirectToUserQuotas(userId) {
            window.location = route('settings.member.quota.edit-user-quota', {team: this.selectedTeamId, member: userId});
        },
        userPermissionsUpdated() {
            this.getTeamUsers();
            this.refreshCreateUserData();
        },
        redirectToUserSalesBehaviorSettings(userId) {
            window.location = route('settings.teams.member.sales-behavior-user-settings.edit-user-sales-behavior', {team: this.selectedTeamId, member: userId});
        },
        resetPasswordLink(user) {
            Swal.fire({
                title: 'Warning',
                text: 'Are you sure you want to send reset password link to ' + user.name + '!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: 'Send Link'
            }).then((result) => {
                if (result.value) {
                    axios.post('/settings/members/send/reset-password/email', {email: user.email}).then((response) => {
                        this.getToast().fire({
                            type: 'success',
                            title: 'Reset password email sent successfully!'
                        });
                    }).catch((error) => {
                        if(error.response && error.response.status === 422) {
                            this.getToast().fire({
                                type: 'error',
                                title: error.response.data.errors.email[0]
                            });
                        }
                    });
                }
            });
        },
        lockUnlockUser(userId, isLocked) {
            Swal.fire({
                title: 'Warning',
                text: 'Are you sure you want to ' + (isLocked ? 'unlock' : 'lock') + ' this user!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: 'Proceed'
            }).then((result) => {
                if(result.value) {
                    let url = isLocked ? '/settings/teams/'+this.selectedTeamId+'/members/'+userId+'/unlock' : '/settings/teams/'+this.selectedTeamId+'/members/'+userId+'/lock';
                    axios.post(url).then((response) => {
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                    });
                    this.getTeamUsers();
                }
            });
        },
        deactivateUsers(userId) {
            Swal.fire({
                title: 'Warning',
                text: 'Are you sure you want to deactivate selected person(s)?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: 'Proceed'
            }).then((result) => {
                if(result.value) {
                    axios.post('/settings/'+this.selectedTeamId+'/members/update/deactivate-multiple-members', {userIds: [userId]}).then((response) => {
                        this.getToast().fire({
                            type: 'success',
                            title: 'User(s) deactivated successfully!'
                        });
                    });
                    this.getTeamUsers();
                }
            });
        },
        activateUsers(userId) {
            Swal.fire({
                title: 'Warning',
                text: 'Are you sure you want to activate selected person(s)?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: 'Proceed'
            }).then((result) => {
                if(result.value) {
                    axios.post('/settings/'+this.selectedTeamId+'/members/update/activate-multiple-members', {userIds: [userId]}).then((response) => {
                        this.getToast().fire({
                            type: 'success',
                            title: 'User(s) reactivated successfully!'
                        });
                    });
                    this.getTeamUsers();
                }
            });
        },
        refreshCreateUserData() {
            this.$refs.MultiTeamManageUserPermissionsModal.$refs.ChooseSetAccess.getTeamAllUsers();
        },
        editUserColor(user) {
            this.$refs.EditUserColorModal.open(user, this.selectedTeamId);
        },
        editUserTeams(user) {
            this.$refs.EditUserTeamsModal.open(user, this.selectedTeamId, this.teams);
        }
    }
}
</script>

<style scoped>
.card .custom-card-header {
    border-color: rgb(203, 214, 226);
    background-color: rgb(245, 248, 250);
    padding: .5rem .75rem;
    border-width: 1px 1px;
    border-bottom: none;
    border-radius: unset;
}
.card .custom-card-body {
    border-width: 1px 1px;
}
.custom-btn-link {
    text-decoration: none;
    box-shadow: none;
    outline: none;
    font-size: 15px;
    font-weight: 600;
}
.custom-btn-link:hover {
    text-decoration: none;
    color: #01B1AF;
}
#accordionTeam {
    margin-top: 20px;
}
.loader-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.7);
    width: 100%;
    height: 100%;
}
.filter-popover-class {
    .popover-body {
        height: auto !important;
        padding: 0 !important;
    }
}
.hover\:theme-custom-background:hover {
    background-color: #01b1af2e;
}
.hover\:theme-custom-color:hover {
    color: #49545a;
}
.multiple-team-user-table thead th {
    background-color: #f5f8fa !important;
}
.bg-grey-custom {
    background-color: #f5f8fa !important;
}
.min-w-25 {
    min-width: 25%;
}
.search-container {
    position: relative;
}
.search-container i {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
}
.loader-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.7);
    width: 100%;
    height: 100%;
}
</style>
